// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/app/anime/[id]": [10,[2,4],[3]],
		"/app/anime/[id]/thread/[threadId]": [11,[2,4,5],[3]],
		"/app/chat": [12,[2],[3]],
		"/app/client": [13,[2,6],[3]],
		"/app/client/files": [14,[2,6],[3]],
		"/app/client/library": [15,[2,6],[3]],
		"/app/client/overview": [16,[2,6],[3]],
		"/app/client/peers": [17,[2,6],[3]],
		"/app/client/trackers": [18,[2,6],[3]],
		"/app/debug": [19,[2],[3]],
		"/app/extensions/install/[...url]": [20,[2],[3]],
		"/app/home": [21,[2],[3]],
		"/app/license": [22,[2],[3]],
		"/app/player": [23,[2],[3]],
		"/app/profile": [24,[2],[3]],
		"/app/schedule": [25,[2],[3]],
		"/app/search": [26,[2],[3]],
		"/app/settings": [27,[2,7],[3]],
		"/app/settings/accounts": [28,[2,7],[3]],
		"/app/settings/app": [29,[2,7],[3]],
		"/app/settings/changelog": [30,[2,7],[3]],
		"/app/settings/client": [31,[2,7],[3]],
		"/app/settings/extensions": [32,[2,7],[3]],
		"/app/settings/interface": [33,[2,7],[3]],
		"/app/settings/mining": [34,[2,7],[3]],
		"/app/settings/mining/anki": [35,[2,7],[3]],
		"/app/settings/mining/audio": [36,[2,7],[3]],
		"/app/settings/player": [37,[2,7],[3]],
		"/app/settings/plugins": [38,[2,7],[3]],
		"/app/stats": [39,[2],[3]],
		"/app/w2g": [40,[2],[3]],
		"/app/w2g/[id]": [41,[2],[3]],
		"/authorize": [42],
		"/setup": [43,[8]],
		"/setup/extensions": [44,[8]],
		"/setup/network": [45,[8]],
		"/setup/storage": [46,[8]],
		"/update": [47]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = true;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);